import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import type {
  SingleTranscriptionResponse,
  TranscriptionAttribute,
} from 'types/Transcriptions';

type MutationVariables = Partial<TranscriptionAttribute>;

export function useAddTranscription() {
  const queryClient = useQueryClient();
  const addTranscription = (transcriptionAttributes: MutationVariables) => {
    const body = {
      data: {
        type: SPARK_RESOURCE_TYPES.TRANSCRIPTIONS,
        attributes: transcriptionAttributes,
      },
    };

    const url = generateURL(SPARK_RESOURCE_TYPES.TRANSCRIPTIONS);
    return fetchWrapper<SingleTranscriptionResponse>({
      url,
      method: 'POST',
      body,
    });
  };

  return useMutation('addTranscription', addTranscription, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`Failed to add transcription: ${error.message}`);
      }
    },
    onSuccess: (data) => {
      const fileID = data.data.attributes.fileID;
      queryClient.invalidateQueries([
        SPARK_RESOURCE_TYPES.TRANSCRIPTIONS,
        fileID,
      ]);
    },
  });
}
